<div class="d-flex">
    <mkt-user [readonly]="true" [value]="value?.user" class="border-right-0" labelPosition="right"></mkt-user>
    <span>{{value?.date | moment: 'MMM DD'}} <small>{{value?.date | moment: "HH:mm A"}}</small></span>
</div>